import type { RouteLocationNormalizedLoaded } from 'vue-router'
import { computed } from 'vue'

import { storeToRefs } from 'pinia'
import { useMetasStore } from '@/stores/metas'

import {
  CUSTOMER_BLOG_PATH,
  CUSTOMER_CATALOG_PATH,
  CUSTOMER_PRODUCT_PATH,
} from '@/constants'

export const useSeo = (route: RouteLocationNormalizedLoaded) => {
  const routeName = computed(() => route.name as string)
  const routePath = computed(() => route.path)

  const isManager = computed(() => /manager/.test(routeName.value))

  const isNotDynamicPage = computed(() => {
    const dynamicPages = [
      RegExp(CUSTOMER_PRODUCT_PATH),
      RegExp(CUSTOMER_CATALOG_PATH),
      RegExp(CUSTOMER_BLOG_PATH),
    ]

    return dynamicPages.every((page) => !page.test(routePath.value))
  })

  const metasStore = useMetasStore()
  const { staticPages } = storeToRefs(metasStore)

  const staticPageMeta = computed(() => {
    if (!isNotDynamicPage.value) return null

    if (routeName.value === '404') {
      return staticPages.value.find((page) => page.route === '/404') ?? null
    }

    return (
      staticPages.value.find((page) => page.route === routePath.value) ?? null
    )
  })

  const h1 = computed(() => {
    if (isManager.value) return null

    if (isNotDynamicPage.value) {
      return staticPageMeta.value?.h1 ?? null
    }

    return null
  })

  return {
    routeName,
    routePath,

    isManager,

    isNotDynamicPage,

    metasStore,
    staticPages,
    staticPageMeta,

    h1,
  }
}
